import { useTheme } from '../../../hooks/useTheme';
import StaggerReveal from '../../../components/feature/StaggerReveal';
import { dentalFlow } from '../../../mocks/dental';

export default function DentalFlow() {
  const { theme } = useTheme();
  const isLight = theme === 'light';
  const accentText = isLight ? '#0f766e' : '#14b8a6';

  const ink = isLight ? '#0a1628' : '#ffffff';
  const sub = isLight ? 'rgba(10,22,40,0.72)' : 'rgba(255,255,255,0.55)';
  const border = isLight ? 'rgba(10,22,40,0.09)' : 'rgba(255,255,255,0.07)';

  return (
    <section
      id="flujo-odontologia"
      className="py-14 md:py-20 px-4 sm:px-6 scroll-mt-24"
      style={{
        background: isLight ? '#ffffff' : '#04101f',
        borderTop: `1px solid ${border}`,
      }}
    >
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span
            className="inline-block text-xs md:text-sm font-semibold tracking-widest uppercase font-body mb-2.5"
            style={{ color: isLight ? '#0e7490' : '#22d3ee' }}
          >
            Recorrido del paciente
          </span>
          <h2
            className="font-heading text-2xl sm:text-3xl md:text-4xl font-bold mb-3"
            style={{ color: ink }}
          >
            Todo el recorrido del paciente en{' '}
            <span style={{ color: accentText }}>una sola plataforma</span>
          </h2>
          <p className="font-body text-sm md:text-base max-w-2xl mx-auto" style={{ color: sub }}>
            Desde que pide la cita hasta el seguimiento posterior, cada paso queda registrado y
            conectado con la agenda, el expediente, la caja y el inventario.
          </p>
        </div>

        <StaggerReveal
          className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-3 md:gap-4 items-stretch"
          staggerDelay={55}
        >
          {dentalFlow.map((step, i) => {
            const accent = i < 3 ? '#06b6d4' : i < 7 ? '#00cfff' : '#14b8a6';
            // Tono legible sobre el fondo claro del chip numerado
            const accentOn = isLight ? (i < 7 ? '#0e7490' : '#0f766e') : accent;
            return (
              <div
                key={step.title}
                className="relative h-full rounded-xl border p-4 flex flex-col gap-2.5"
                style={{
                  borderColor: border,
                  background: isLight ? '#f6fafd' : 'rgba(7,27,46,0.75)',
                }}
              >
                <div className="flex items-center gap-2.5">
                  <span
                    className="w-7 h-7 rounded-lg flex items-center justify-center font-heading text-xs font-extrabold flex-shrink-0"
                    style={{ backgroundColor: accent + '1f', color: accentOn }}
                  >
                    {i + 1}
                  </span>
                  <i className={`${step.icon} text-lg`} style={{ color: accentOn }} aria-hidden="true" />
                </div>
                <p
                  className="font-body text-xs md:text-[13px] font-semibold leading-snug"
                  style={{ color: ink }}
                >
                  {step.title}
                </p>
                {i < dentalFlow.length - 1 && (
                  <span
                    className="dental-flow-line hidden lg:block absolute top-7 -right-4 w-4 h-[2px]"
                    style={{ color: accent + '80' }}
                    aria-hidden="true"
                  />
                )}
              </div>
            );
          })}
        </StaggerReveal>
      </div>
    </section>
  );
}
